// src/pages/UnidadeOrganica/CriarUnidadeOrganicaPage.jsx
import React from 'react';
import UnidadeOrganicaForm from '../../components/UnidadeOrganica/UnidadeOrganicaForm';

const CriarUnidadeOrganicaPage = () => {
    return (
        <div>
            <h1>Criar Unidade Orgânica</h1>
            <UnidadeOrganicaForm onSuccess={() => alert('Unidade orgânica criada com sucesso!')} />
        </div>
    );
};

export default CriarUnidadeOrganicaPage;
